"use client";

import React from "react";
import { Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4 justify-center">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-20 bg-primary/10 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-wrap items-center justify-center gap-y-2">
      {menuItems.map((item, i) => <div key={item.id} data-index={i} className="flex items-center">
          {i > 0 && <Sparkles className="w-3 h-3 text-primary/60 mx-3 sm:mx-5" aria-hidden="true" />}
          <Link to={item.href || "#"} className="text-primary/90 hover:text-primary transition-colors text-base font-serif italic">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function Footer() {
  return <footer id="footer" className="text-primary py-8 border-t border-primary/10">
      <div className="container mx-auto px-4 flex flex-col items-center">
        
        <MenuProvider menu_id="17" className="w-full flex justify-center">
          <FooterMenu />
        </MenuProvider>

        <div className="text-center text-primary/60 text-base font-serif italic mt-6">
          <p>&copy; {new Date().getFullYear()} Abracadabra Events. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}